import { convertFileToBase64 } from "../../utils/getBase64";

export const mapContractsToApi = async (data, ownerId, ownerType) => {
  return {
    data: {
        type: "contracts",
        attributes:  {
            contractDocument: data.contractDocument?.[0]
              ? await convertFileToBase64(data.contractDocument[0])
              : null,
            startDate: data.startDate,
            endDate: data.endDate,
            ownerId: ownerId, // should be id for supplier or driver
            ownerType: ownerType, // should be Supplier or Driver
          },
    }
  };
};
